import Vue from 'vue'
import Router from 'vue-router'
import Tournees from './views/Tournees.vue'
import TourneeDetails from './views/TourneeDetails.vue'
import OidcCallback from './views/OidcCallback.vue'
import OidcSignout from './views/OidcSignout.vue'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'tournees',
      component: Tournees
    },
    {
      path: '/tournee/:id',
      name: 'tourneeDetails',
      component: TourneeDetails
    },
    {
      path: '/signin-oidc',
      name: 'oidcCallback',
      component: OidcCallback,
      meta: {
        isOidcCallback: true,
        isPublic: true
      }
    },
    {
      path: '/signout-oidc',
      name: 'oidcSignout',
      component: OidcSignout,
      meta: {
        isOidcCallback: true,
        isPublic: true
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(vuexOidcCreateRouterMiddleware(store))

export default router